import { ParsedFormat } from "../FormatAndSizePreference.js";


export interface TechWithUpdatableSource {

    getCurrentFormat(): ParsedFormat;
    updateFormat(f: ParsedFormat): Promise<void>;

}


/**
 * Represents a native HTML5 video player for Video On Demand (VOD) playback.
 * 
 * This class provides methods to attach a video element, load and play video sources,
 * update the video format, reload the source while optionally keeping the current playback time,
 * and dispose of the video element. It manages the loaded state and allows querying the current format.
 * 
 * @remarks
 * - The player expects a `ParsedFormat` object containing the video source URL and size information.
 * - The video element is configured with the provided format's URL and dimensions.
 * - The `load` method sets up the video element and marks it as loaded.
 * - The `play` method ensures the video is loaded before playback.
 * - The `updateFormat` method allows switching to a new video source and preserves the current playback time.
 * - The `reloadSource` method reloads the current format and optionally keeps the playback position.
 * - The `dispose` method clears the video source.
 * 
 * @example
 * ```typescript
 * const player = new NativeVODPlayer(format);
 * player.attachVideoElement(videoElement);
 * await player.load();
 * await player.play();
 * ```
 */
export class NativeVODPlayer implements TechWithUpdatableSource {


    private video: HTMLVideoElement;


    private loaded: boolean;

    public constructor(
        private currentFormat: ParsedFormat
    ) {
        this.loaded = false;
    }


    public attachVideoElement(v: HTMLVideoElement): NativeVODPlayer {

        if (!this.video) {
            this.video = v;
            return this;
        }

    }

    public load(): Promise<void> {
        //    this.video.src = 
        if (!this.loaded) {
            console.log("[AGGRO] Called load");
            this.video.src = this.currentFormat ? this.currentFormat.url : "";
            this.video.preload = "metadata";
            this.video.width = this.currentFormat.parsedSize.width;
            this.video.height = this.currentFormat.parsedSize.height;
            this.loaded = true;

        }
        return Promise.resolve();
    }

    public dispose() {
        console.log("[AGGRO] called dispose");
        if (this.video) this.video.src = "";
    }




    public play(): Promise<void> {
        return this.load().then(_ => {
            return this.video.play();
        });
    }

    getCurrentFormat(): ParsedFormat {
        return this.currentFormat;
    }

    reloadSource(keepCurrentTime: boolean): Promise<void> {
        const timing = keepCurrentTime ? this.video.currentTime : 0;
        this.video.src = this.currentFormat.url;
        this.video.width = this.currentFormat.parsedSize.width;
        this.video.height = this.currentFormat.parsedSize.height;
        this.video.load();
        this.video.currentTime = timing;
        return Promise.resolve();
    }

    updateFormat(f: ParsedFormat): Promise<void> {
        if (f && (!this.currentFormat ||
            this.currentFormat.url != f.url)) {
            console.log("[AGGRO] update format");
            const currentTime = this.video.currentTime;
            this.currentFormat = f;
            this.video.src = f.url;
            this.video.width = f.parsedSize.width;
            this.video.height = f.parsedSize.height;
            this.video.load();
            this.video.currentTime = currentTime;
            return Promise.resolve();

        }
        else return Promise.resolve();
    }


    hasBeenLoaded(): boolean {
        return this.loaded;
    }

}
